import { createContext } from 'react';

/**
 * @internal
 */
var LayoutGroupContext = /*#__PURE__*/createContext(null);
export { LayoutGroupContext };